<script setup lang="ts">
import type { NewsListItemContent } from '~/types/news';

defineProps<{
  newsItems: NewsListItemContent[];
  loading: boolean;
}>();
</script>

<template>
  <BaseList
    :loading="loading"
    transition-name="product-list"
    class="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4"
    :aria-label="$t('Aria.NewsListPage.NewsList')"
  >
    <li
      v-for="(newsItem, index) in newsItems"
      :key="`${newsItem.headline}-${index}`"
      class="flex items-center justify-center"
    >
      <PartialsNewsListItem :news-item="newsItem" />
    </li>
  </BaseList>
</template>
